"use client";
import { createContext, useContext } from "react";
import { ToolSinglePageProps } from "@/types/strapi/tool";

export type ToolSinglePageContextType = ToolSinglePageProps | null;

export const ToolSinglePageContext = createContext<ToolSinglePageContextType>(null);

export const useToolSinglePageContext = () => useContext(ToolSinglePageContext);
